import { createStore, combineReducers, applyMiddleware, Action } from 'redux';
import thunkMiddleware, { ThunkMiddleware, ThunkAction, ThunkDispatch } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import { assetsReducer } from './assets/reducers';
import { devicesReducer } from './devices/reducers';
import { flashLogReducer } from './flash-log/reducers';
import { bulkFlashReducer } from './bulk-device-flash/reducers';
import { transactionsReducer } from './transactions/reducers';
import { searchReducer } from './search/reducers';
import { loginReducer } from './login/reducers';
import { commandsReducer } from './commands/reducers';
import { userPreferenceReducer } from './user-preferences-v2/reducers';
import { entitlementsReducer, currentRoleReducer } from './entitlements/reducers';
import { snackbarReducer } from './snackbar/reducers';
import { modalReducer } from './modal/reducers';
import { remoteFlashReducer } from './configure/remote-flash/reducers';
import { softwareLibraryManagementReducer } from './software-library-management/reducers';
import { adminReducer } from './admin/file-type-configuration/reducers';
import { deviceTypeReducer } from './admin/device-type-configuration/reducers';
import { configurationReducer } from './configure/configuration/reducers';
import { configurationSofwareReducer } from './configure/software/reducers';
import { sftpReducer } from './sftp/reducers';
import { vimsSFTPReportReducer } from './vims-sftp-files/reducers';
import { deviceMigrationReducer } from './device-migration/reducers';

const rootReducer = combineReducers({
  assets: assetsReducer,
  devices: devicesReducer,
  flashLog: flashLogReducer,
  bulkFlash: bulkFlashReducer,
  libraryManagement: softwareLibraryManagementReducer,
  transactions: transactionsReducer,
  search: searchReducer,
  login: loginReducer,
  commands: commandsReducer,
  userPreference: userPreferenceReducer,
  entitlements: entitlementsReducer,
  userRole: currentRoleReducer,
  snackbar: snackbarReducer,
  modal: modalReducer,
  firmware: remoteFlashReducer,
  admin: adminReducer,
  deviceType: deviceTypeReducer,
  configStatus: configurationReducer,
  configSoftware: configurationSofwareReducer,
  sftp: sftpReducer,
  vimsSFTPReport: vimsSFTPReportReducer,
  deviceMigration: deviceMigrationReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppThunkResult<R> = ThunkAction<R, AppState, undefined, Action>;
export type AppThunkDispatch = ThunkDispatch<AppState, undefined, Action>;

export default function configureStore() {
  const middlewares = [thunkMiddleware as ThunkMiddleware<AppState>];
  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(rootReducer, composeWithDevTools(middleWareEnhancer));

  return store;
}
